import React from 'react';

const variants = {
  category: 'bg-sand-100 text-ink-700',
  pending: 'bg-amber-50 text-amber-600',
  accepted: 'bg-uae-green/10 text-uae-green',
  completed: 'bg-sand-100 text-ink-700',
  cancelled: 'bg-uae-red/10 text-uae-red',
  cancellation_requested: 'bg-orange-50 text-orange-600',
  default: 'bg-sand-100 text-ink-700',
};

export default function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span className={['inline-block text-xs font-medium px-2.5 py-0.5 rounded', variants[variant], className].join(' ')}>
      {children}
    </span>
  );
}
